import { sortingMethods } from '../../../../../../constants/table';
import CustomCell from '../../../../../../components/Table/CustomCell';

export const detailsHeadings = [
  {
    title: 'Device Name',
    name: 'deviceName',
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterScriptExecutionAffectedDevices',
    sortingCellField: 'DeviceName',
    sortFieldName: 'OrderQuery',
    width: '25%',
  },
  {
    title: 'File Path',
    name: 'filePath',
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterScriptExecutionAffectedDevices',
    sortingCellField: 'FilePath',
    sortFieldName: 'OrderQuery',
    width: '25%',
  },
  {
    title: 'User Writeable',
    name: 'userWriteable',
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterScriptExecutionAffectedDevices',
    sortingCellField: 'UserWriteable',
    sortFieldName: 'OrderQuery',
    width: '20%',
  },
  {
    title: 'Event Time',
    name: 'eventTime',
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterScriptExecutionAffectedDevices',
    sortingCellField: 'EventTime',
    sortFieldName: 'OrderQuery',
    width: '20%',
  },
  {
    title: 'Last Seen',
    name: 'lastSeen',
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterScriptExecutionAffectedDevices',
    sortingCellField: 'LastSeen',
    sortFieldName: 'OrderQuery',
    width: '20%',
  },
];

export const columnsOrderDetails = [
  { name: 'deviceName', styles: { wordBreak: 'break-word' } },
  { name: 'filePath', styles: { wordBreak: 'break-word' } },
  { name: 'userWriteable', styles: { wordBreak: 'break-word' } },
  { name: 'eventTime', styles: { wordBreak: 'break-word' } },
  { name: 'lastSeen', styles: { wordBreak: 'break-word' } },
];

export const sidebarList = [
];
